import { createSlice } from "@reduxjs/toolkit";

export const modalSlice = createSlice({
  name: "modal",
  initialState: {
    title: "", // current  title state management
    isOpen: false, // modal state management for opening closing
    bodyType: "", // modal content management
    size: "", // modal content management
    extraObject: {},
    identifier: "",
    inputValue:"",
    userAnswer :false,
    changeFileData: null, // data temp to update state
    changeFolderData: null, // data temp to update state
    newFolderData: null, // data temp to update state
    newMasterData: null, // data temp to update state
    changeMasterData: null, // data temp to update state
    deleteFileData: null, // data temp to delete file
    deleteFolderData: null, // data temp to delete folder
    deleteImageData: null,
    deleteMultiData: null, // data temp to delete multi
    deleteItemClassMasteData: null,
    stack: [],  // モーダルのスタック管理
    childExtraObject: {},
    childIdentifier: "",
    shouldStack  : false,
    // フォルダ／ファイル権限の登録・更新が成功するたびに increment される版番号。
    // 各物件タブ (BukkenFiles / BukkenDrawing / BukkenInspection / BukkenImages) の
    // index.js でこれを useSelector で監視し、値が変わったら folders-children を再取得して
    // 社外ユーザー閲覧可否 (has_external_viewer) の表示を最新化する。
    // アプリ起動時に 0 へ初期化されるだけで、セッション中は単調増加。JS の安全整数内で十分。
    folderFilePermissionUpdateVersion: 0
  },
  reducers: {
    openModal: (state, action) => {
      const { title, bodyType, extraObject, size, identifier,shouldStack } = action.payload;
      const isStack = shouldStack !== undefined ? shouldStack : state.shouldStack;
      if (state.isOpen && isStack) {
        state.stack.push({
          bodyType: state.bodyType,
          extraObject: state.extraObject,
          title: state.title,
          identifier: state.identifier,
          size: state.size
        });
      }
      state.isOpen = true;
      state.bodyType = bodyType;
      state.title = title;
      state.size = size || "md";
      state.extraObject = extraObject;
      state.identifier = identifier || "";
      state.shouldStack  = isStack;
    },
    closeModal: (state, action) => {
       if (state.stack.length > 0 && state.shouldStack) {
        const prevModal = state.stack.pop();
        state.bodyType = prevModal.bodyType;
        state.extraObject = prevModal.extraObject;
        state.title = prevModal.title;
        state.childIdentifier = state.identifier;
        state.identifier = prevModal.identifier;
        state.childExtraObject = {};
        state.size = prevModal.size;
        state.isOpen = true;
      } else {
        // スタックが空 = すべてのモーダルをクローズ
        state.isOpen = false;
        state.bodyType = "";
        state.title = "";
        state.extraObject = {};
        state.identifier = "";
        state.inputValue="";
        state.childExtraObject = {};
        state.shouldStack = false;
        state.childIdentifier="";
      }
    },
    closeModalForOK: (state, action) => {
       if (state.stack.length > 0 && state.shouldStack ) {
        const prevModal = state.stack.pop();
        state.bodyType = prevModal.bodyType;
        state.extraObject = prevModal.extraObject;
        state.title = prevModal.title;
        state.childIdentifier = state.identifier;
        state.identifier = prevModal.identifier;
        state.size = prevModal.size;
        state.isOpen = true;
        state.userAnswer=true;
        state.childExtraObject = action.payload?.extraObject ?? {};
       
      } else {
        // スタックが空 = すべてのモーダルをクローズ
        state.isOpen = false;
        state.bodyType = "";
        state.title = "";
        state.extraObject = action.payload?.extraObject ?? {};
        state.userAnswer=true;
        state.shouldStack = false;
        state.childIdentifier = "";
      }
      // state.isOpen = false;
      // state.bodyType = "";
      // state.title = "";
      // state.extraObject = action.payload?.extraObject ?? {};
      // state.userAnswer=true;
    },
    closeModalForNo: (state, action) => {
       if (state.stack.length > 0 && state.shouldStack ) {
        const prevModal = state.stack.pop();
        state.bodyType = prevModal.bodyType;
        state.extraObject = prevModal.extraObject;
        state.title = prevModal.title;
        state.childIdentifier = state.identifier;
        state.identifier = prevModal.identifier;
        state.size = prevModal.size;
        state.isOpen = true;
        state.userAnswer=false;
        state.childExtraObject = {};
      } else {
        // スタックが空 = すべてのモーダルをクローズ
        state.isOpen = false;
        state.bodyType = "";
        state.title = "";
        state.userAnswer=false;
        state.shouldStack = false;
        state.childExtraObject = {};
        state.childIdentifier = "";
      }
      // state.isOpen = false;
      // state.bodyType = "";
      // state.title = "";
      // state.userAnswer=false;
      // state.extraObject = action.payload?.extraObject ?? {};
    },
    setTextInputModalValue:(state, action) => {
      state.inputValue =action.payload;
    },
    setChangeFileData: (state, action) => {
      state.changeFileData = action.payload;
    },
    setChangeFolderData: (state, action) => {
      state.changeFolderData = action.payload;
    },
    setNewFolderData: (state, action) => {
      state.newFolderData = action.payload;
    },
    setNewMasterData: (state, action) => {
      state.newMasterData = action.payload;
    },
    setChangeMasterData: (state, action) => {
      state.changeMasterData = action.payload;
    },
    setDeleteFileData: (state, action) => {
      state.deleteFileData = action.payload;
    },
    setDeleteFolderData: (state, action) => {
      state.deleteFolderData = action.payload;
    },
    setDeleteImageData: (state, action) => {
      state.deleteImageData = action.payload;
    },
    setDeleteMultiFolderData: (state, action) => {
      state.deleteMultiData = action.payload;
    },
    setDeleteItemMasterData: (state, action) => {
      state.deleteItemMasteData = action.payload;
    },
    setExtraObject: (state, action) => {
      state.extraObject = action.payload;
    },
    // フォルダ／ファイル権限の登録・更新が成功したら呼ぶ。
    // 監視側のタブが version の変化を検知して folders-children を再取得する。
    bumpFolderFilePermissionUpdate: (state) => {
      state.folderFilePermissionUpdateVersion += 1;
    }
  }
});

export const {
  openModal,
  closeModal,
  closeModalForOK,
  closeModalForNo,
  setTextInputModalValue,
  setChangeFileData,
  setChangeFolderData,
  setNewFolderData,
  setNewMasterData,
  setChangeMasterData,
  setDeleteFileData,
  setDeleteFolderData,
  setDeleteImageData,
  setDeleteMultiFolderData,
  setDeleteItemMasterData,
  setExtraObject,
  bumpFolderFilePermissionUpdate
} = modalSlice.actions;

export default modalSlice.reducer;
